import type { AsyncData } from "#app";
import type { IModelResponse, ModelResponse } from "~/services/base/dto/base.dto";
import type { IModelConversationDetailMessageResponse, IModelConversationDetailResponse, ModelPOSTConversationAssociationConversationFile } from "./dto/conversation.detail.dto";
import type { IModelConversationRespone, IModelSharedConversationMessageDetail, ModelThumb } from "./dto/conversation.dto";


export class ConversationRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getConversation(params: any): Promise<AsyncData<IModelResponse<IModelConversationRespone[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation`, this.configService, {
      params,
    });
    return dataResult;
  }

  async getConversationDetail(id: string | number): Promise<AsyncData<IModelResponse<IModelConversationDetailResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation-message/${id}`, this.configService);
    return dataResult;
  }

  async createConversation(params: any): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation`, this.configService, {
      method: 'POST',
      body: {
        data: params,
      }
    });
    return dataResult;
  }


  async putConversation(params: any): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation`, this.configService, {
      method: 'PUT',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async initialConversation(params: any, signal?: AbortSignal): Promise<Response> {
    const response = await useApiFetchSSE(`${this.llmService}/v1/conversation-association/conversation/${params.id}/initial-llm`, {
      method: 'PUT',
      body: JSON.stringify({
        data: params,
      }),
      signal,
    });
    return response;
  }

  async appendConversation(params: any, signal?: AbortSignal): Promise<Response> {
    const response = await useApiFetchSSE(`${this.llmService}/v1/conversation-association/conversation/${params.id}/append-llm`,  {
      method: 'PUT',
      body: JSON.stringify({
        data: params,
      }),
      signal,
    });
    return response;
  }

  // async editConversation(params: any): Promise<AsyncData<any, any>> {
  //   const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation/${params.id}/latest-message`, this.configService, {
  //     method: 'PUT',
  //     body: {
  //       data: params,
  //     }
  //   });
  //   return dataResult;
  // }

  async deleteConversation(params: any): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation/${params.id}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }

  async conversationAssociationConversationFile(params: any): Promise<AsyncData<ModelResponse<ModelPOSTConversationAssociationConversationFile[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation-file`, this.configService, {
      method: 'POST',
      body: params
    });
    return dataResult;
  }

  async thumbFeedback(params: any): Promise<AsyncData<any, any>> { 
    const dataResult = await this.api(`${this.llmService}/v1/conversation-message/thumbs`, this.configService, {
      method: 'PUT',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async exportConversation(params: any): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/export/${params.type}/${params.id}`, this.configService, {});
    return dataResult;
  }

  async getConversationSharedDetail(id: string | number): Promise<AsyncData<IModelResponse<IModelConversationDetailResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/shared/conversation-message/${id}`, this.configService);
    return dataResult;
  }

  async getMessageSharedDetail(id: string | number): Promise<AsyncData<IModelResponse<IModelSharedConversationMessageDetail>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/shared/message-conversation-preset/${id}`, this.configService);
    return dataResult;
  }

  async abbortConversationMessage(params: any): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-message/abort-status`, this.configService, {
      method: 'PUT',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async getConversationAndHistory(params: any): Promise<AsyncData<IModelResponse<IModelConversationRespone[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/conversation-association/conversation-history`, this.configService, {
      params,
    });
    return dataResult;
  }
}
